// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oc-sidebar {
  font-size: 13px;
  overflow-y: auto;
  overflow-x: hidden;
}

.oc-brand {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
}

.oc-brand-text {
  font-size: 13px;
  font-weight: 600;
}

.oc-nav {
  padding: 8px 6px 12px;
}

.oc-nav-group + .oc-nav-group {
  margin-top: 10px;
}

.group-title {
  padding: 4px 12px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.7;
}

.oc-nav-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 13px;
  color: #f5f5f5;
  text-decoration: none;
}

.oc-nav-link .ico {
  display: flex;
  align-items: center;
  justify-content: center;
}

.oc-nav-link .text {
  white-space: normal;
  word-break: break-word;
  min-width: 0;
}

.oc-nav-link:hover {
  background: rgba(255, 255, 255, 0.06);
}

.oc-nav-link.active {
  background: rgba(35, 161, 209, 0.18);
  color: #ffffff;
  font-weight: 500;
}

.oc-sidebar-footer {
  margin-top: auto;
  padding: 10px 12px 12px;
}

.oc-btn.ghost.full {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
  font-size: 13px;
}

`, "",{"version":3,"sources":["webpack://./src/components/layout/css/sidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB","sourcesContent":[".oc-sidebar {\n  font-size: 13px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.oc-brand {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 14px;\n}\n\n.oc-brand-text {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.oc-nav {\n  padding: 8px 6px 12px;\n}\n\n.oc-nav-group + .oc-nav-group {\n  margin-top: 10px;\n}\n\n.group-title {\n  padding: 4px 12px;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  opacity: 0.7;\n}\n\n.oc-nav-link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #f5f5f5;\n  text-decoration: none;\n}\n\n.oc-nav-link .ico {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.oc-nav-link .text {\n  white-space: normal;\n  word-break: break-word;\n  min-width: 0;\n}\n\n.oc-nav-link:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.oc-nav-link.active {\n  background: rgba(35, 161, 209, 0.18);\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.oc-sidebar-footer {\n  margin-top: auto;\n  padding: 10px 12px 12px;\n}\n\n.oc-btn.ghost.full {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: flex-start;\n  font-size: 13px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
